import React from 'react';

import { Box, Stack, Tooltip, Typography } from '@mui/material';

import { UI } from './operationalUi';

interface Props {
  position?: string;
  label?: string;
  level?: string;
  n?: number;
  reason?: string;
  compact?: boolean;
}
export default function PositionPill({ position = 'unscored', label, level, n, reason, compact }: Props) {
  const key = position === 'inLine' || position === 'within' ? 'in_line' : position;
  const pair = UI[key] || UI.unscored;
  const text =
    label ||
    {
      below: 'Well below peers',
      in_line: 'In line with peers',
      above: 'Well above peers',
      unscored: 'No peer group yet',
    }[key] ||
    'No peer group yet';
  return (
    <Stack direction="row" spacing={0.6} alignItems="center" flexWrap="wrap" useFlexGap>
      <Tooltip title={reason || ''}>
        <Box
          component="span"
          sx={{
            ...pair,
            px: 1,
            py: 0.25,
            borderRadius: 5,
            fontSize: compact ? 12 : 13,
            lineHeight: 1.35,
            whiteSpace: 'normal',
            display: 'inline-block',
          }}
        >
          {text}
        </Box>
      </Tooltip>
      {level === 'country' && (
        <Typography
          component="span"
          sx={{
            fontSize: 12,
            px: 0.75,
            border: `1px solid ${UI.teal}`,
            borderRadius: 5,
            color: UI.teal,
            whiteSpace: 'nowrap',
          }}
        >
          country peers ({n})
        </Typography>
      )}
    </Stack>
  );
}
